module.exports = __webpack_public_path__ + "public-ui/img/b3.199b1618.svg";